import { render } from "./ContactNotifPicker.vue?vue&type=template&id=be8b6abe&scoped=true"
import script from "./ContactNotifPicker.vue?vue&type=script&lang=ts"
export * from "./ContactNotifPicker.vue?vue&type=script&lang=ts"

import "./ContactNotifPicker.vue?vue&type=style&index=0&id=be8b6abe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be8b6abe"

export default script